import React from "react";
import { sendPostRequest } from "../../Client";
import { toast } from "react-toastify"; // Optional: for feedback
import { usePreReg } from "../PreRegContext";

const UserRow = ({ item, onDelete }) => {
  const { contextPreReg, setContextPreReg } = usePreReg();

  const deleteUser = async (ballerzUserID) => {
    const res = await sendPostRequest(`registration/booking/user/delete`, {
      bookingReference: contextPreReg,
      ballerzUserID: ballerzUserID,
    });

    if (res?.status === "success") {
      onDelete(ballerzUserID);
      toast.success("User deleted");
    }
  };

  const confirmDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to delete ${item.firstname} ${item.lastname}?`
      )
    ) {
      deleteUser(item.ballerzUserID);
    }
  };

  return (
    <div
      className="
    w-full sm:w-2/3 mx-auto
    flex flex-col items-center          /* mobile: column + center */
    sm:flex-row sm:items-center sm:justify-between  /* desktop: row + spaced */
    bg-[#1f2644] rounded-lg p-3 mt-3
    text-white font-kallisto gap-3
  "
    >
      <div className="w-full sm:w-auto sm:min-w-[30%] bg-[#0d1121] p-2 rounded flex justify-center items-center">
        <span className="text-xl sm:text-2xl font-bold uppercase text-center">
          {item.username}
        </span>
      </div>

      <div
        className="
      flex-1 px-2
      text-center 
      sm:text-left sm:ml-2 sm:mr-40 
    "
      >
        <span className="text-xl sm:text-2xl Kallisto_Bold block truncate">
          {item.firstname} {item.lastname}
        </span>
      </div>

      <div className="flex justify-center sm:justify-end w-full sm:w-auto">
        <button
          onClick={confirmDelete}
          className="bg-[#d60f0f] text-white px-4 py-2 rounded text-base sm:text-xl font-bold w-full sm:w-auto"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default UserRow;
